import styled from 'styled-components'

export const LeftArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;
    transform: rotate(180deg);

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`

export const RightArrow = styled.button`
  svg {
    width: 100%;
    height: 100%;
    stroke-width: 4px;

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      stroke-width: 1px;
    }
  }
`

export const MobileBannerArrow = styled.svg`
  display: none;
  position: absolute;
  width: 42px;
  height: 15px;
  bottom: 2.4rem;
  color: ${props => props.theme.colors.white};
  left: 50%;
  transform: translateX(-50%);
`

export const CarouselWrapper = styled.section`
  position: relative;
  // height: ${props => (props.fillScreen ? '100vh' : '54rem')};

  &:first-of-type {
    margin-top: -10rem;
    min-height: 630px;

    h2 {
      font-size: 3.4rem;

      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        font-size: 6.4rem;
      }
    }

    ${MobileBannerArrow} {
      display: block;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        display: none;
      }
    }

    .slick-dots {
      bottom: 6.4rem;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        bottom: 3rem;
      }
    }
  }

  .slick-slide > div > section > div:before {
    background: rgba(0,0,0,0.0)
  }

  .slick-slide > div > section {
    height: 56.4vw;
  }

  .slick-slide > div > section > div > img {
    min-height: 56.4vw;
  }

  .slick-dots {
    bottom: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 100%;
      text-align: center;
    }

    li {
      cursor: auto;
      width: auto;
      height: 2px;

      button {
        display: inline-block;
        width: 5.2rem;
        /* To increase clickable area of the position indicators */
        padding: 3rem 0;
        margin: -3rem 0;

        &:before {
          content: '';
          opacity: 1;
          width: 5.2rem;
          border: 1px solid ${props => props.theme.colors.lightGrey};
          height: 1px;
        }

        @media screen and (min-width: ${props =>
    props.theme.responsive.small}) {
          margin-right: 1.5rem;
          width: 6.1rem;

          &::before {
            width: 6.1rem;
          }
        }
      }

      &.slick-active {
        button {
          &:before {
            border: 1px solid ${props => props.theme.colors.cobalt};
          }
        }
      }
    }

    button {
      width: 100%;
      height: auto;
      padding: 0;
      margin-bottom: 100px;
    }
  }

  ${LeftArrow},
  ${RightArrow} {
    position: absolute;
    width: 24px;
    height: 24px;
    color: ${props => props.theme.colors.white};
    top: 50%;
    z-index: 1;
    cursor: pointer;

    &::before {
      content: '';
    }

    &:hover,
    &:focus {
      color: ${props => props.theme.colors.white};
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 32px;
      height: 32px;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      width: 48px;
      height: 48px;
    }
  }

  ${LeftArrow} {
    left: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      left: 3rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      left: 5rem;
    }
  }

  ${RightArrow} {
    right: 2rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      right: 3rem;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      right: 5rem;
    }
  }

  .mainslider {
    @media screen and (max-width: 1024px) {
      display: none;
    }

    h2 {
      font-size: 40px !important;
      line-height: 45px;
      font-weight: 300;
      letter-spacing: .02em;
      padding: 6px 0 0;
      text-transform: uppercase;
      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        font-size: 4rem;
      }
    }
  
    h5 {
      font-size: 15px;
      line-height: 22.4px;
      margin: 0 auto;
      //width: 60%;
      @media screen and (max-width: ${props => props.theme.responsive.medium}) {
        width: 75%;
      }
      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        width: 65%;
      }
    }
  
    .slick-slide > div > section > div:nth-child(2) {
      width: 60%;
      min-height: 250px;
      margin-bottom: 0;
      margin-top: -31px;
      margin: 0 auto;
      position: absolute;
      bottom: 53px;
    }
  
    .slick-slide > div > section > div:nth-child(2) > div:nth-child(3)  {
      margin-top: 2.5vw;
      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        margin-top: 5rem;
      }  
    }
  
    .slick-slide > div > section > div:nth-child(2) {
      @media screen and (max-width: ${props => props.theme.responsive.medium}) {
        width: 75%;
      }
      @media screen and (min-width: ${props => props.theme.responsive.large}) {
        width: 60%;
      }
    }
  }

  .thumbnailslider {
    @media screen and (max-width: 1024px) {
      display: none;
    }
  }
  
  .mobileslider {
    h2 {
      font-family: "myriad-pro",sans-serif;
      font-weight: 100;
      font-size: 32px;
      line-height: 36px;
      letter-spacing: .02em;
    }

    @media screen and (min-width: 640px) {
      h2 {
        font-size: 42px !important;
        line-height: 46px;
      }
    } 

    h2:after {
      border-color: #3d609f;
    }

    h5 {
      font-size: 16px;
      line-height: 22px;
      margin: 22px auto 22px;
      max-width: 460px;
    }

    section > div > div  {
      margin-top: 0px;
    }

    .slick-slide > div > section {
      height: 105vh;
      border-bottom: 5px solid #264f98;
      //background: linear-gradient(to right, #192e54 0%, #3d61a2 50%, #192e54 100%);
    }

    .slick-slide > div > section > div > img {
      min-height: 100vh;
    }
    
    @media screen and (min-width: 1024px) {
      display: none;
    }
  }

  


`
export const ThumbnailImg = styled.img`
`
export const ThumbnailSliderWrapper = styled.div`
  //border: solid 1px orange;
  margin: 0 auto;
  width: 55vw;
  position: absolute;
  left: 0;
  right: 0;
  top: 43vw;
  @media (min-width: 1025px) and (max-width: 1215px) {
    top: 52vw;
  }
  @media (min-width: 1215px) and (max-width: 1315px) {
    top: 45vw;
  }
  @media (max-width: 1024px) {
    display: none;
  }

  .thumbnailWrap {
    position: relative;
  }

  .caption {
    position: absolute;
    bottom: 0;
    left: 0;
    color: white;
    margin-left: 0.5vw;
    margin-bottom: 0.5vw;
    margin-right: 0.5vw;
    // width: 11.5vw;
    font-size: 1vw;
    line-height: 1.5vw;
  }
  
  .slick-slide {
    padding: 6px;
  }

  .slick-slide.slick-current img {
    border: solid 1px white;
  }
`
